export default __webpack_public_path__ + "static/media/pk.8a1682f7.svg";